// Module
var code = "<user-settings></user-settings> ";
// Exports
export default code;